<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Ajukan"
      back-button-text="Kembali"
      next-button-text="Lanjut"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- accoint details tab -->
      <tab-content
        title="Biodata"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Biodata Mahasiswa
              </h5>
              <small class="text-muted">
                Lengkapi biodata mahasiswa.
              </small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="nama"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="nama"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="name"
                    v-model="userData.name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="johndoe"
                    readonly
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Email"
                label-for="email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="userData.email"
                    type="email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="john.doe@email.com"
                    readonly
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
           <b-col md="6">
              <b-form-group
                label="Alamat"
                label-for="alamat"
              >
                <validation-provider
                  #default="{ errors }"
                  name="alamat"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="alamat"
                    v-model="userData.alamat"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Alamat"
                    readonly
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="NPM"
                label-for="npm"
              >
                <validation-provider
                  #default="{ errors }"
                  name="npm"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="npm"
                    v-model="berkas.npm"
                    :state="errors.length > 0 ? false:null"
                    placeholder="NPM"
                    readonly
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Jurusan"
                label-for="jurusan"
              >
                <validation-provider
                  #default="{ errors }"
                  name="jurusan"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jurusanOption.options"
                    v-model="berkas.jurusan_id"
                    placeholder="Pilih Jurusan"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Jenjang"
                label-for="jenjang"
              >
                <validation-provider
                  #default="{ errors }"
                  name="jenjang"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jenjangOption.options"
                    v-model="berkas.jenjang_id"
                    placeholder="Pilih Jenjang"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Prodi"
                label-for="prodi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="prodi"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="prodiOption.options"
                    v-model="berkas.prodi_id"
                    placeholder="Pilih prodi"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Peminatan"
                label-for="peminatan"
              >
                <validation-provider
                  #default="{ errors }"
                  name="peminatan"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <v-select
                    id="gender"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="peminatanOption.options"
                    v-model="berkas.peminatan_id"
                    placeholder="Pilih Jurusan"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- personal details tab -->
      <tab-content
        title="Berkas Sidang"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Berkas Sidang
              </h5>
              <small class="text-muted">Lengkapi Berkas Sidang Anda</small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Judul"
                label-for="judul"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Judul"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="judul"
                    v-model="berkas.judul"
                    placeholder="Judul"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Jenis Sidang"
                label-for="jenis sidang"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Jenis Sidang"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="jenis_sidang"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="jenisSidangOption.options"
                    v-model="berkas.jenis_sidang_id"
                    placeholder="Pilih Jenis Sidang"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Proses Persidangan"
                label-for="proses persidangan"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Proses Persidangan"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="proses_persidangan"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="prosesPersidanganOption.options"
                    v-model="berkas.proses_persidangan_id"
                    placeholder="Pilih Proses Persidangan"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Tanggal Sidang"
                label-for="tanggal_sidang"
              >
                <validation-provider
                  #default="{ errors }"
                  name="tanggal_sidang"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-datepicker v-model="berkas.tanggal_sidang" :min="min" :max="max" locale="id"></b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Jam"
                label-for="jam"
              >
                <validation-provider
                  #default="{ errors }"
                  name="jam"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-timepicker 
                    locale="id" 
                    v-model="berkas.jam"
                   />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Dosen Pembimbing"
                label-for="Dosen Pembimbing"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Pembimbing"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="dosen_pembimbing"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="berkas.dosen_id"
                    placeholder="Pilih Dosen Pembimbing"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Dosen Penguji"
                label-for="Dosen Penguji"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Dosen Penguji"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                   <v-select
                    id="dosen_penguji"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="dosenOption.options"
                    v-model="berkas.dosen_penguji_id"
                    placeholder="Pilih Dosen Penguji"
                    multiple
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="File Naskah Sidang"
                label-for="File Naskah Sidang"
              >
                <validation-provider
                  #default="{ errors }"
                  name="File Naskah Sidang"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-file
                    ref="file-input"
                    v-model="berkas.file"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- address  -->
      <tab-content
        title="Berkas Persiapan"
        :before-change="validationFormAddress"
      >
        <validation-observer
          ref="addressRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Berkas Persiapan Sidang
              </h5>
              <small class="text-muted">Lengkapi berkas persiapan anda</small>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Berkas Presentasi (pptx)"
                label-for="Berkas Presentasi (pptx)"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Berkas Presentasi (pptx)"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-file
                    ref="file-input"
                    v-model="berkas.file_presentasi"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Link Video Presentasi"
                label-for="Link Video Presentasi"
              >
                <validation-provider
                  #default="{ errors }"
                  name="link_video"
                  rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                >
                  <b-form-input
                    id="link_video"
                    v-model="berkas.link_video"
                    :state="errors.length > 0 ? false:null"
                    placeholder="https://youtube.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <!-- Modal Loading -->
      <div>
        <b-modal id="modal-center-loading" centered title="Loading" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-if="showModal === 1">
          <div class="d-flex justify-content-center mt-2">
            <b-spinner
            :variant="'dark'"
            ></b-spinner>
          </div>
          <div class="d-flex justify-content-center mt-2">
           Loading....
          </div>
          <b-button class="mt-3" block @click="reload()" variant="primary">Muat Ulang</b-button>
        </b-modal>
      </div>
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BCalendar,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
  BModal,
  BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import { codeIcon } from './code'
import {
  getUserDetail,
  getJurusan,
  getJenjang,
  getProdi,
  getPeminatan,
  getJenisSidang,
  getProsesPersidangan,
  getDosen,
  postBerkas,
  updateBerkas,
  getPengajuanSidangDetail,
  getRuangan,
  getProgram,
  getWaktuUjian,
  getJawabanPersetujuan,
} from '@/connection-api/master'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    BButton,
    BCalendar,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BModal,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  data() {
      // 15th two months prior
      const minDate = new Date('2023-06-12')
      minDate.setDate(minDate.getDate())
      // 15th in two months
      const maxDate = new Date('2023-07-12')
      maxDate.setDate(maxDate.getDate())

    return {
      showModal: 1,
      file: null,
      minTime: '08:00',
      maxTime: '16:00',
      min: minDate,
      max: maxDate,
      selectedContry: '',
      selectedLanguage: '',
      userData: {},
      berkas: {},
      required,
      email,
      codeIcon,
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
      jurusanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jurusan --' },
        ],
      },
      jenjangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenjang --' },
        ],
      },
      peminatanOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Peminatan --' },
        ],
      },
      prodiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Prodi --' },
        ],
      },
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Jenis Sidang --' },
        ],
      },
      prosesPersidanganOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Proses Persidangan --' },
        ],
      },
      dosenOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Dosen --' },
        ],
      },
    }
  },
  mounted() {
      this.$bvModal.show('modal-center-loading')
      var success_check = []
      var error_check = []
      if(!this.$route.params.uuid){
          postBerkas()
          .then(response => {
            if (response.data.success == true) {
              success_check.push('success')
              this.completeCheck(success_check)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Sidang',
                  icon: 'EditIcon',
                  variant: 'success',
                  text: 'Redirecting ...',
                },
              })
              setTimeout(() => {
                this.$router.push({ 
                  name: 'pengajuan-sidang-edit', 
                  params: { uuid: response.data.data.uuid } 
                })
              }, 1000);
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Pengajuan Sidang',
                  icon: 'EditIcon',
                  variant: 'danger',
                  text: response.data.message,
                },
                duration: 5000,
              })
            }
          })
          .catch(error => console.log(error));
        } else {
          getPengajuanSidangDetail(this.$route.params.uuid)
            .then(response => {
              this.berkas = response.data.data;
              success_check.push('success')
              this.completeCheck(success_check)
            })
          .catch(error => console.log(error));

          getUserDetail()
            .then(response => {
              this.userData = response.data.data;
              this.berkas.npm = this.userData.npm
              this.berkas.jurusan_id = this.userData.jurusan_id
              this.berkas.jenjang_id = this.userData.jenjang_id
              this.berkas.prodi_id = this.userData.prodi_id
              this.berkas.peminatan_id = this.userData.peminatan_id
            })
          .catch(error => console.log(error));
        }

      //API data
      getJawabanPersetujuan()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.jawabanPersetujuanOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });

      getRuangan()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.ruanganOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });

      getDosen()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.dosenOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });

      getWaktuUjian()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.waktuUjianOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });

      getJurusan()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.jurusanOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });

      getProsesPersidangan()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.prosesPersidanganOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });

      getJenisSidang()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.jenisSidangOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });

      getJenjang()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.jenjangOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });

      getProgram()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.programOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });

      getProdi()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.prodiOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });

      getPeminatan()
      .then(response => {
      if (response.data.length > 0) {
        response.data.forEach(element => {
          this.peminatanOption.options.push({
            title: element.nama,
            value: element.uuid,
          })
        })
        success_check.push('success')
        this.completeCheck(success_check)
      }
      })
      .catch(error => {
        error_check.push(error)
      });
  },
  methods: {
    completeCheck(success_check)
    {
      if(success_check.length == 12)
      {
        this.showModal = 0
      }
    },
    reload()
    {
      window.location.reload()
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()
      const day = date.getDate()
      // Return `true` if the date should be disabled
      // return weekday === 0 || weekday === 6 || day === 14
        return weekday === 0
    },
    formSubmitted() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Form Submitted',
          icon: 'EditIcon',
          variant: 'success',
        },
      })
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            this.berkas.flag = 'Biodata'
            updateBerkas(this.berkas)
            .then(response => {
              if (response.data.success == true) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'success',
                    text: 'Data berhasil disimpan',
                  },
                  duration: 5000,
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Pengajuan Sidang',
                    icon: 'EditIcon',
                    variant: 'success',
                    text: 'Data berhasil disimpan',
                  },
                })
              }
            })
            .catch(error => console.log(error));
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
